module.exports = __webpack_public_path__ + "static/media/Pools Comming.0a009aee.png";